import React from "react";
import { Radio } from "antd";
import "./Category.css";

const Category = ({ title, activeValue, onChange }) => {
  return (
    <div className="categoryRadioRoot">
      <Radio.Group
        value={activeValue}
        onChange={onChange}
        buttonStyle="solid"
        className="categoryRadioGroup"
      >
        <Radio.Button value={title} className="categoryRadioBtn">
          <div className="categoryWrapper">
            <div className="categoryTitle">{title}</div>
            <div className="categorySelectedBar" />
          </div>
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

export default Category;
